const ID = 'notice';

export default ID;
